module.exports = __webpack_public_path__ + "img/vívoactive® 5.0f221d2b.jpg";